import angular from 'angular';
import { AddressStaticComponent } from './static.component';
import { ZipCodeFilter } from '../../src/filters';

export const AddressStaticModule = angular
  .module('angular-common.address.static', [ZipCodeFilter.name])
  .component('updAddressStatic', AddressStaticComponent);
